import { render, staticRenderFns } from "./zixuninfo.vue?vue&type=template&id=b792f814&scoped=true"
import script from "./zixuninfo.vue?vue&type=script&lang=js"
export * from "./zixuninfo.vue?vue&type=script&lang=js"
import style0 from "./zixuninfo.vue?vue&type=style&index=0&id=b792f814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b792f814",
  null
  
)

export default component.exports